export class Counter {
  public value = -1;

  up() {
    return ++this.value;
  }
}
